export const SortColumns = Object.freeze({
  NAME: 'name',
  VIEWED: 'viewed',
  QUIZZES: 'quizes',
  SELF_RATING: 'selfRating',
  STUDENT_NOTES: 'studentNotes',
});
